import { render, staticRenderFns } from "./PotencialCustomers.vue?vue&type=template&id=b0b45482&scoped=true&"
import script from "./PotencialCustomers.vue?vue&type=script&lang=js&"
export * from "./PotencialCustomers.vue?vue&type=script&lang=js&"
import style0 from "./PotencialCustomers.vue?vue&type=style&index=0&id=b0b45482&prod&lang=scss&scoped=true&"
import style1 from "./PotencialCustomers.vue?vue&type=style&index=1&id=b0b45482&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b45482",
  null
  
)

export default component.exports